import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Tabs, Spin, message } from "antd";
import SubscriptionBanner from "../../../../assets/images/bg/subscription_home-logo.svg";
import {  useSelector } from "react-redux";
import { getBaseUrl } from '../../../../utils/envAccess';
import "../../../../screens/Subscription/subscription.css"
import { ArrowRightOutlined } from "@ant-design/icons";

const Services = () => {
    const [showInfo, setShowInfo] = useState(true);
    const [caregiverGroups, setCaregiverGroups] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedGroupId, setSelectedGroupId] = useState(null);
    const [caregiverDetails, setCaregiverDetails] = useState([]);
    const [loadingDetails, setLoadingDetails] = useState(false);
    const auth = useSelector(state => state.authentication?.userAuth);
    const token = auth?.obj?.token || auth?.token || '';

    // Fetch caregiver details by group ID
    const fetchCaregiverDetails = useCallback(async (groupId) => {
        setLoadingDetails(true);
        setSelectedGroupId(groupId);
        try {
            const baseUrl = getBaseUrl();
            const response = await fetch(`${baseUrl}/Patient/GetCareGivers/${groupId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Failed to fetch caregiver details');
            }

            const data = await response.json();
            setCaregiverDetails(data);
        } catch (error) {
            console.error('Error fetching caregiver details:', error);
            message.error('Failed to load caregiver details. Please try again later.');
        } finally {
            setLoadingDetails(false);
        }
    }, [token]);

    const handleBooking = (groupId) => {
        fetchCaregiverDetails(groupId);
    };

    // Fetch caregiver groups from API
    const fetchCaregiverGroups = useCallback(async () => {
        setLoading(true);
        try {
            // Get baseUrl from your config/environment
            const baseUrl = getBaseUrl();
            const response = await fetch(`${baseUrl}/Patient/CareGiverGroup`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Failed to fetch caregiver groups');
            }

            const data = await response.json();
            setCaregiverGroups(data);
        } catch (error) {
            console.error('Error fetching caregiver groups:', error);
            message.error('Failed to load care providers. Please try again later.');
        } finally {
            setLoading(false);
        }
    }, [token]); // Add token as dependency

    // Fetch data on component mount
    useEffect(() => {
        fetchCaregiverGroups();
    }, [fetchCaregiverGroups]);

    return (
        <>
            {/* Two Column Layout - BOOKING text left, picture right */}
            <Row gutter={[32, 32]} style={{ marginBottom: '10px', minHeight: '100px' }}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        height: '80%',
                        padding: '20px 0'
                    }}>
                        <h2 style={{
                            color: '#335CAD',
                            fontWeight: 'bold',
                            fontSize: '28px',
                            marginBottom: '24px',
                            margin: '0 0 24px 0'
                        }}>
                            BOOKING
                        </h2>
                        <p style={{
                            color: '#333',
                            fontSize: '16px',
                            lineHeight: '1.4',
                            margin: '0 0 20px 0'
                        }}>
                            Schedule an appointment with our care providers to receive personalized support, thoughtfully tailored to your unique needs, preferences, and goals.
                        </p>
                        <p style={{
                            color: '#333',
                            fontSize: '15px',
                            lineHeight: '1.4',
                            margin: 0
                        }}>
                            Our team is here to guide you every step of the way.
                        </p>
                    </div>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        padding: '20px 0'
                    }}>
                        <img
                            src={SubscriptionBanner}
                            alt="Subscription Banner"
                            style={{
                                width: '100%',
                                maxWidth: '400px',
                                height: 'auto',
                                objectFit: 'contain'
                            }}
                        />
                    </div>
                </Col>
            </Row>

            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginTop: '20px'
                    }}>
                        <button
                            onClick={() => setShowInfo(!showInfo)}
                            style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '18px',
                                color: '#666'
                            }}
                        >
                            {showInfo ? '×' : '+'}
                        </button>
                    </div>
                </Col>
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                </Col>
            </Row>

            <Row gutter={[16, 16]} style={{ marginTop: '20px' }}>
                {/* Left Side - How to Book */}


                {/* Right Side - Care Providers with Tabs */}
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <div style={{
                        border: '1px solid #D6E2F5',
                        borderRadius: 12,
                        background: '#fff',
                        boxSizing: 'border-box',
                        height: '100%',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            color: '#335CAD',
                            fontWeight: 600,
                            fontSize: 20,
                            padding: '24px 32px 0px 32px',
                            textAlign: 'center'
                        }}>
                            Care Providers
                        </div>

                        {loading ? (
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: '40px',
                                minHeight: '200px'
                            }}>
                                <Spin size="large" />
                            </div>
                        ) : caregiverGroups.length > 0 ? (
                            <Tabs
                                defaultActiveKey="0"
                                centered
                                style={{ padding: '0 20px 20px 20px' }}
                                items={caregiverGroups.map((group, index) => ({
                                    key: index.toString(),
                                    label: group.groupName,
                                    children: (
                                        <div style={{
                                            padding: '12px',
                                            minHeight: '150px'
                                        }}>
                                            {group.careGivers && group.careGivers.length > 0 ? (
                                                <ul style={{
                                                    listStyle: 'none',
                                                    padding: 0,
                                                    margin: 0,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '12px'
                                                }}>
                                                    {group.careGivers.map((caregiver, idx) => (
                                                        <li
                                                            key={idx}
                                                            style={{
                                                                padding: '12px 16px',
                                                                background: '#f8fafc',
                                                                borderRadius: '8px',
                                                                border: '1px solid #e2e8f0',
                                                                fontSize: '15px',
                                                                color: '#334155',
                                                                fontWeight: 500
                                                            }}
                                                        >
                                                            {caregiver}
                                                        </li>
                                                    ))}
                                                </ul>

                                            ) : (
                                                <p style={{
                                                    textAlign: 'center',
                                                    color: '#94a3b8',
                                                    fontSize: '14px',
                                                    margin: '20px 0'
                                                }}>
                                                    No caregivers available in this group
                                                </p>
                                            )}
                                            <button
                                                onClick={() => handleBooking(group.groupId)}
                                                style={{
                                                    marginTop: '12px',
                                                    padding: '8px 16px',
                                                    background: '#335CAD',
                                                    color: '#fff',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                Book Appointment
                                            </button>
                                        </div>
                                    ),
                                }))}
                            />
                        ) : (
                            <div style={{
                                padding: '40px 20px',
                                textAlign: 'center',
                                color: '#94a3b8'
                            }}>
                                <p>No care provider groups available at this time.</p>
                            </div>
                        )}
                    </div>
                </Col>
            </Row>

            {/* Caregiver Details Section */}
            {selectedGroupId && (
                <Row gutter={[16, 16]} style={{ marginTop: '30px' }}>
                    <Col xs={24}>
                        <div style={{
                            border: '1px solid #D6E2F5',
                            borderRadius: 12,
                            background: '#fff',
                            padding: '24px',
                            boxSizing: 'border-box'
                        }}>
                            <div style={{
                                color: '#335CAD',
                                fontWeight: 600,
                                fontSize: 20,
                                marginBottom: '20px',
                                textAlign: 'center'
                            }}>
                                Available Caregivers
                            </div>

                            {loadingDetails ? (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: '40px'
                                }}>
                                    <Spin size="large" />
                                </div>
                            ) : caregiverDetails.length > 0 ? (
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '16px'
                                }}>
                                    {caregiverDetails.map((caregiver, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                padding: '20px',
                                                background: '#f8fafc',
                                                borderRadius: '8px',
                                                border: '1px solid #e2e8f0',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                flexWrap: 'wrap',
                                                gap: '12px'
                                            }}
                                        >
                                            <div style={{ flex: 1, minWidth: '200px' }}>
                                                <div style={{
                                                    fontSize: '18px',
                                                    fontWeight: 600,
                                                    color: '#1e293b',
                                                    marginBottom: '4px'
                                                }}>
                                                    {caregiver.fullname}
                                                </div>
                                                <div style={{
                                                    fontSize: '14px',
                                                    color: '#64748b'
                                                }}>
                                                    {caregiver.rolename}
                                                </div>
                                            </div>

                                            {caregiver.link && (
                                                <button
                                                    //onClick={() => window.location.href = caregiver.link}
                                                    onClick={() => window.open(caregiver.link, '_blank')}
                                                    style={{
                                                        padding: '10px 20px',
                                                        background: '#335CAD',
                                                        color: '#fff',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px'
                                                    }}
                                                >
                                                    View Profile
                                                    <ArrowRightOutlined style={{ fontSize: '12px' }} />
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p style={{
                                    textAlign: 'center',
                                    color: '#94a3b8',
                                    fontSize: '14px'
                                }}>
                                    No caregiver details available
                                </p>
                            )}
                        </div>
                    </Col>
                </Row>
            )}
        </>
    );
};

export default Services;